import React from 'react';
import { Box, Toolbar, Container } from '@mui/material';
import { useSelector } from 'react-redux';
import AppBar from '../AppBar';
import Sidebar from '../Sidebar';
import DynamicBreadcrumbs from '../Breadcrumbs/DynamicBreadcrumbs';

const MainLayout = ({ children }) => {
  const { sidebarPermanent } = useSelector((state) => state.ui);
  const drawerWidth = 280; // Ensure this matches your Sidebar's width

  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      
      {/* Main content area */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: { 
            md: sidebarPermanent ? `calc(100% - ${drawerWidth}px)` : '100%' 
          },
        }}
      >
        <AppBar />
        
        {/* Toolbar spacer to prevent content from going under the AppBar */}
        <Toolbar />
        
        {/* Page content */}
        <Container maxWidth="xl" sx={{ py: 3, px: 3 }}>
          <DynamicBreadcrumbs />
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default MainLayout;

// // src/components/common/Layout/MainLayout.jsx
// import React from 'react';
// import { Box, Toolbar, Container } from '@mui/material';
// import { useSelector } from 'react-redux';
// import AppBar from '../AppBar';
// import Sidebar from '../Sidebar';
// import DynamicBreadcrumbs from '../Breadcrumbs/DynamicBreadcrumbs';
// import { useNavigation } from '../../../hooks/useNavigation';

// const MainLayout = ({ children }) => {
//   const { sidebarPermanent } = useSelector((state) => state.ui);
//   const { breadcrumbs } = useNavigation();

//   return (
//     <Box sx={{ display: 'flex', minHeight: '100vh' }}>
//       {/* Sidebar */}
//       <Sidebar />
                
//       {/* Main content area */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           width: {
//             md: sidebarPermanent ? 'calc(100% - 280px)' : '100%',
//           },
//           transition: 'width 0.3s ease', // Smooth transition when sidebar toggles
//         }}
//       >
//         {/* AppBar */}
//         <AppBar />
                
//         {/* Toolbar spacer */}
//         <Toolbar />
                
//         {/* Page content with breadcrumbs */}
//         <Box
//           sx={{
//             flexGrow: 1,
//             bgcolor: 'background.default',
//             minHeight: 'calc(100vh - 64px)', // Account for AppBar height
//           }}
//         >
//           {/* Container for consistent spacing */}
//           <Container 
//             maxWidth="xl" 
//             sx={{ 
//               py: { xs: 2, sm: 3 },
//               px: { xs: 2, sm: 3 },
//               height: '100%',
//             }}
//           >
//             {/* Breadcrumbs - only show if there are multiple levels */}
//             {breadcrumbs && breadcrumbs.length > 1 && (
//               <Box sx={{ mb: 2 }}>
//                 <DynamicBreadcrumbs />
//               </Box>
//             )}
            
//             {/* Page content */}
//             <Box
//               sx={{
//                 flexGrow: 1,
//                 display: 'flex',
//                 flexDirection: 'column',
//                 minHeight: breadcrumbs?.length > 1 ? 'calc(100% - 60px)' : '100%', // Adjust for breadcrumbs
//               }}
//             >
//               {children}
//             </Box>
//           </Container>
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default MainLayout;

// // src/components/common/Layout/MainLayout.jsx
// import React from 'react';
// import { Box, Toolbar } from '@mui/material';
// import { useSelector } from 'react-redux';
// import AppBar from '../AppBar';
// import Sidebar from '../Sidebar';

// const MainLayout = ({ children }) => {
//   const { sidebarPermanent } = useSelector((state) => state.ui);

//   return (
//     <Box sx={{ display: 'flex', minHeight: '100vh' }}>
//       {/* Sidebar */}
//       <Sidebar />
      
//       {/* Main content area */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           width: {
//             md: sidebarPermanent ? 'calc(100% - 280px)' : '100%',
//           },
//         }}
//       >
//         {/* AppBar */}
//         <AppBar />
        
//         {/* Toolbar spacer */}
//         <Toolbar />
        
//         {/* Page content */}
//         <Box
//           sx={{
//             flexGrow: 1,
//             p: { xs: 2, sm: 3 },
//             bgcolor: 'background.default',
//             minHeight: 'calc(100vh - 64px)', // Account for AppBar height
//           }}
//         >
//           {children}
//         </Box>
//       </Box>
//     </Box>
//   );
// };

// export default MainLayout;
